const getDisplayRowPagination = (page = 1, limit = 10, total: number) => {
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return `${start}-${end}`;
};

export { getDisplayRowPagination };
